(function () {
  'use strict';
  var R = (window.NV && window.NV.routes) || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' };
  var lastFocus = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Mobile menu */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    var open = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', String(!open));
    nav.hidden = open;
  });

  /* Cart drawer */
  function drawer() { return document.getElementById('CartDrawer'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-drawer');
    var close = $('[data-cart-close].icon-btn', d);
    if (close) close.focus();
    return true;
  }

  function closeDrawer() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-drawer');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function setCount(n) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function renderDrawer(html, keepOpen) {
    if (!html) return;
    var wrap = document.getElementById('shopify-section-cart-drawer');
    if (!wrap) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#shopify-section-cart-drawer') || tmp;
    wrap.innerHTML = fresh.innerHTML;
    if (keepOpen) {
      var d = drawer();
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('has-drawer');
    }
  }

  function refreshCount() {
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      if (openDrawer()) e.preventDefault();
    } else if (e.target.closest('[data-cart-close]')) {
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* Add to bag */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-ajax-cart]')) return;
    if (!drawer()) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"][name="add"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var old = form.querySelector('.form-msg');
    if (old) old.remove();

    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);

    fetch(R.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = document.createElement('p');
          msg.className = 'form-msg stock-note';
          msg.textContent = res.data.description || res.data.message || 'This item could not be added. Please try again.';
          form.appendChild(msg);
          return;
        }
        if (res.data.sections && res.data.sections['cart-drawer']) {
          renderDrawer(res.data.sections['cart-drawer'], false);
        }
        refreshCount();
        openDrawer();
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* Change quantities in the drawer */
  function changeLine(line, qty) {
    var d = drawer();
    if (d) d.classList.add('is-loading');
    return fetch(R.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (c.sections) renderDrawer(c.sections['cart-drawer'], true);
        if (typeof c.item_count === 'number') setCount(c.item_count); else refreshCount();
      })
      .catch(function () { window.location.href = R.cart; })
      .finally(function () { var d2 = drawer(); if (d2) d2.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-change]');
    if (!b) return;
    var line = b.closest('[data-line]');
    if (!line) return;
    changeLine(parseInt(line.getAttribute('data-line'), 10), Math.max(0, parseInt(b.getAttribute('data-qty-change'), 10) || 0));
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-qty-input]')) return;
    var line = e.target.closest('[data-line]');
    if (!line) return;
    changeLine(parseInt(line.getAttribute('data-line'), 10), Math.max(0, parseInt(e.target.value, 10) || 0));
  });

  /* Scent family + size filters */
  function sizeBucket(size, key) {
    var s = parseFloat(size) || 0;
    if (!s) return false;
    if (key === '15') return s <= 20;
    if (key === '50') return s > 20 && s <= 60;
    if (key === '100') return s > 60;
    return true;
  }

  function applyFilter(scope, family, size) {
    var grid = $('[data-finder-grid]', scope);
    if (!grid) return;
    var shown = 0;
    $all('.card', grid).forEach(function (card) {
      var fams = (card.getAttribute('data-families') || '').split(/\s+/);
      var okFam = family === 'all' || fams.indexOf(family) !== -1;
      var okSize = !size || sizeBucket(card.getAttribute('data-size'), size);
      card.hidden = !(okFam && okSize);
      if (!card.hidden) shown++;
    });
    var empty = $('[data-finder-empty]', scope);
    if (empty) empty.hidden = shown !== 0;
  }

  function scopeOf(el) { return el.closest('[data-scent-finder]') || el.closest('.wrap') || document; }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.chip[data-family]');
    if (!chip) return;
    var group = chip.parentElement;
    $all('.chip[data-family]', group).forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
    var scope = scopeOf(chip);
    var sizeChip = $('.chip[data-size-filter]', group);
    applyFilter(scope, chip.getAttribute('data-family'), sizeChip ? sizeChip.getAttribute('data-size-filter') : null);
  });

  function applyHash() {
    var m = /^#size-(15|50|100)$/.exec(window.location.hash);
    var finder = $('[data-scent-finder]');
    if (!finder) return;
    var group = $('.families', finder);
    var existing = $('.chip[data-size-filter]', group);
    if (existing) existing.remove();
    var active = $('.chip[data-family][aria-pressed="true"]', group);
    var fam = active ? active.getAttribute('data-family') : 'all';
    if (!m) { applyFilter(finder, fam, null); return; }
    var labels = { '15': '15 ml', '50': '50 ml', '100': '90 ml and up' };
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'chip';
    chip.setAttribute('aria-pressed', 'true');
    chip.setAttribute('data-size-filter', m[1]);
    chip.innerHTML = labels[m[1]] + ' <span aria-hidden="true">✕</span><span class="visually-hidden">Clear size filter</span>';
    chip.addEventListener('click', function () {
      history.replaceState(null, '', window.location.pathname + window.location.search);
      applyHash();
    });
    group.appendChild(chip);
    applyFilter(finder, fam, m[1]);
    finder.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  window.addEventListener('hashchange', applyHash);
  document.addEventListener('DOMContentLoaded', applyHash);

  /* Collection sort */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sort-select]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* Product page */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var img = $('.js-main-img');
      if (img) {
        img.src = thumb.getAttribute('data-thumb');
        img.srcset = thumb.getAttribute('data-thumb-srcset');
      }
      $all('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
      return;
    }
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var input = step.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var v = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
      input.value = Math.max(1, v);
      return;
    }
    if (e.target.closest('[data-sticky-add]')) {
      var form = $('[data-product-root] form[data-ajax-cart]');
      if (form) {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-variant-select]')) return;
    var opt = e.target.options[e.target.selectedIndex];
    var price = $('[data-price]');
    if (price && opt) price.textContent = opt.getAttribute('data-price');
    var url = new URL(window.location.href);
    url.searchParams.set('variant', e.target.value);
    history.replaceState(null, '', url.toString());
  });

  document.addEventListener('DOMContentLoaded', function () {
    var add = $('[data-add-btn]');
    var sticky = $('[data-sticky-buy]');
    if (!add || !sticky || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      });
    }).observe(add);
  });
})();